export interface ActionDropdownProps {
  onRunReport: () => void;
  onCopyReport: () => void;
  onDeleteReport: () => void;
}

export interface ModalFooterProps {
  onCloseModel: () => void;
  onDeleteReport: () => void;
}

export enum ActionType {
  Run = 'run',
  Copy = 'copy',
  Delete = 'delete'
}
